<template>
  <div class="fixed bg_faint inset-0">
    <div class="absolute top-3 left-3 z-50">
      <div class="bg-white rounded-sm px-3 py-2 hover:bg-gray-100 cursor-pointer" @click="closeMap">
        <close-icon :width="'w-4'" :height="'h-4'"></close-icon>
      </div>
    </div>
    <div id="map2" class="w-full h-full"></div>
  </div>
</template>

<script>
// import Swal from 'sweetalert2'
import CloseIcon from '../icons/CloseIcon.vue'
import { mapState } from 'vuex'
export default {
  components: { CloseIcon },
  props: {
    from: String,
    to: String,
    driver_uid: String,
    coordinates: Object
  },
  data() {
    return {
      myCoordinates: {},
      watch_position_id: null,
      mapZoom: 7,
      location: false
    }
  },
  computed: {
    ...mapState('current_orders', ['driver_location'])
  },
  watch: {
    location(val) {
      if (val) {
        this.initMap()
      }
    },
    driver_location(val) {
      if (val.lat == undefined) {
        this.initMap()
      }
    }
  },
  methods: {
    initMap() {
      // eslint-disable-next-line no-undef
      const directionsService = new google.maps.DirectionsService()
      // eslint-disable-next-line no-undef
      const directionsRenderer = new google.maps.DirectionsRenderer()
      // eslint-disable-next-line no-undef
      const map = new google.maps.Map(document.getElementById('map2'), {
        zoom: 7,
        center: { lat: this.coordinates.lat, lng: this.coordinates.lng },
        mapTypeControl: false,
        zoomControl: false,
        streetViewControl: false
      })

      // eslint-disable-next-line no-undef
      google.maps.event.addListener(map, 'zoom_changed', function () {
        //Set local storage variables.
        //mapCentre = map.getCenter()

        //localStorage.mapLat = mapCentre.lat()
        //localStorage.mapLng = mapCentre.lng()
        localStorage.mapZoom = map.getZoom()
      })

      if (this.driver_location != undefined) {
        // eslint-disable-next-line no-undef
        new google.maps.Marker({
          position: { lat: this.driver_location.lat, lng: this.driver_location.lng },
          icon: './../img/m2.png',
          map: map
        })
      }
      directionsRenderer.setMap(map)

      //const onChangeHandler = function () {
      this.calculateAndDisplayRoute(directionsService, directionsRenderer)
      //}
      //document.getElementById('start').addEventListener('change', onChangeHandler)
      //document.getElementById('end').addEventListener('change', onChangeHandler)
    },

    calculateAndDisplayRoute(directionsService, directionsRenderer) {
      directionsService.route(
        {
          origin: {
            query: this.from
          },
          destination: {
            query: this.to
          },
          // eslint-disable-next-line no-undef
          travelMode: google.maps.TravelMode.DRIVING
        },
        (response, status) => {
          if (status === 'OK') {
            directionsRenderer.setDirections(response)
          } else {
            window.alert('Directions request failed due to ' + status)
          }
        }
      )
    },
    onMapSuccess(position) {
      this.myCoordinates = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      }
      this.location = true
    },
    onMapError(error) {
      console.log('Error: ', error.message)
    },
    //when user clicks "get Location"
    getLocation() {
      navigator.geolocation.watchPosition(this.onMapSuccess, this.onMapError, {
        enableHighAccuracy: true
      })
    },
    closeMap() {
      this.$emit('open-map', false)
    }
  },
  mounted() {
    //this.initMap()
    //window.setInterval(this.getLocation(), 3000)
    if (this.driver_uid != undefined) {
      this.$store.dispatch('current_orders/driverLocation', this.driver_uid)
    }
    this.mapZoom = localStorage.getItem('mapZoom')
    this.getLocation()
  }
}
</script>

<style scoped>
.bg_faint {
  background-color: rgba(0, 0, 0, 0.192);
}
</style>
